/**
 * Das eigene Konto (`/api/v1/me`). Eigene Datei statt `lib/tickets.ts`, weil
 * dort ausschliesslich mandanten-gebundene Pfade stehen — ein Konto gehoert
 * der Plattform.
 *
 * Die E-Mail-Adresse fehlt hier mit Absicht: sie laeuft ueber Better-Auth
 * (`authClient.changeEmail`) und den Bestaetigungslink.
 */
import type { CurrentUser, UpdateProfileInput } from '@tickethub/shared';
import { api } from './api';
import { apiPaths } from './api-paths';

export const meApi = {
  load: () => api.get<CurrentUser>(apiPaths.me),
  updateProfile: (input: UpdateProfileInput) => api.patch<CurrentUser>(apiPaths.me, input),
};
